import { CONTENT_AND_STREAM_GET } from '../queries';
import { request } from '../request';
export const fetchValidStream = async (client, contentId) => {
    const result = await client.fetchQuery({
        queryKey: ['contentAndStream'],
        queryFn: async () => request({
            query: CONTENT_AND_STREAM_GET,
            variables: { id: contentId },
        }),
        gcTime: 0,
        staleTime: 0,
    });
    if (result.errors) {
        throw new Error('An unknown error occurred fetching a valid stream. Please contact support.');
    }
    return {
        content: result.Content,
        stream: result.stream,
    };
};
//# sourceMappingURL=fetchValidStream.js.map